<template>
  <div class="page-home">
    <div class="columns">
      <div class="column">
        This is home.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  metaInfo: {
    title: 'home'
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    refresh () {
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-home {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// Home.vue?3557ad04